<script setup>
import { defineProps, ref } from 'vue'
import { useRouter } from 'vue-router'
import UiAside from './UiAside.vue'

const router = useRouter()

const props = defineProps({
    title: String,
    hideHeader: Boolean,
    hideBack: Boolean,
    hideMenu: Boolean,
    hideBox: Boolean,
    backgroundColor: String,
    textColor: String,
    bell: Boolean,
})

let aside_show = ref(false)

function back() {
    router.back()
}
</script>

<template>
    <div>
        <header v-if="!hideHeader" :class="hideBox ? 'h-0' : 'h-16'" class="w-full block z-40">
            <div :class="{
                'bg-header-bg': !backgroundColor, 
                'text-header-text': !textColor
            }" :style="{
                backgroundColor: backgroundColor,
                color: textColor
            }" class="w-full h-16 fixed left-0 top-0 z-40 flex items-center justify-center">
                <div class="h-full px-2 flex items-center absolute left-0 top-0">
                    <button v-if="!hideBack" @click="back()" class="px-3 -ml-2 h-full relative flex items-center">
                        <svg class="w-5 h-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                            <path d="M73.4 297.4C60.9 309.9 60.9 330.2 73.4 342.7L233.4 502.7C245.9 515.2 266.2 515.2 278.7 502.7C291.2 490.2 291.2 469.9 278.7 457.4L173.3 352L544 352C561.7 352 576 337.7 576 320C576 302.3 561.7 288 544 288L173.3 288L278.7 182.6C291.2 170.1 291.2 149.8 278.7 137.3C266.2 124.8 245.9 124.8 233.4 137.3L73.4 297.3z"/>
                        </svg>
                    </button>
                    <slot name="left"></slot>
                </div>
                <div class="w-1/2 h-full flex items-center justify-center">
                    <p v-if="title" class="text-lg leading-5 font-bold text-center line-clamp-2">{{title}}</p>
                    <slot name="center"></slot>
                </div>
                <div class="h-full px-2.5 flex items-center absolute right-0 top-0">
                    <slot name="right"></slot>
                    <router-link v-if="bell" to="/event" class="h-full px-1.5 flex items-center">                       
                        <svg class="w-6 md:w-7 h-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                            <path d="M320 64C306.7 64 296 74.7 296 88L296 97.7C214.6 109.3 152 179.4 152 264L152 278.5C152 316.2 142 353.2 123 385.8L101.1 423.2C97.8 429 96 435.5 96 442.2C96 463.1 112.9 480 133.8 480L506.2 480C527.1 480 544 463.1 544 442.2C544 435.5 542.2 428.9 538.9 423.2L517 385.7C498 353.1 488 316.1 488 278.4L488 263.9C488 179.3 425.4 109.2 344 97.6L344 87.9C344 74.6 333.3 63.9 320 63.9zM488.4 432L151.5 432L164.4 409.9C187.7 370 200 324.6 200 278.5L200 264C200 197.7 253.7 144 320 144C386.3 144 440 197.7 440 264L440 278.5C440 324.7 452.3 370 475.5 409.9L488.4 432zM252.1 528C262 556 288.7 576 320 576C351.3 576 378 556 387.9 528L252.1 528z"/>
                        </svg>
                    </router-link>
                    <button v-if="!hideMenu" @click="aside_show = true" class="h-full px-1.5 flex items-center">                       
                        <svg class="w-5 md:h-6 h-auto" viewBox="0 0 22 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.42853 2.69629H20.5716C21.1774 2.69629 21.6669 2.2031 21.6669 1.59522C21.6669 0.987617 21.1777 0.494141 20.5716 0.494141H1.42853C0.823808 0.494141 0.333252 0.98733 0.333252 1.59522C0.333252 2.2031 0.823808 2.69629 1.42853 2.69629ZM20.5713 8.20167H1.42853C0.822419 8.20167 0.333252 8.69486 0.333252 9.30274C0.333252 9.91063 0.822419 10.4038 1.42853 10.4038H20.5716C21.1774 10.4038 21.6669 9.91063 21.6669 9.30274C21.6666 8.69486 21.1744 8.20167 20.5713 8.20167ZM20.5713 16.0001H1.42853C0.824085 16.0001 0.333252 16.4933 0.333252 17.1012C0.333252 17.709 0.823808 18.2022 1.42853 18.2022H20.5716C21.1774 18.2022 21.6669 17.709 21.6669 17.1012C21.6666 16.4936 21.1774 16.0001 20.5713 16.0001Z"/>
                        </svg>
                    </button>
                </div>
            </div>
        </header>
        <slot></slot>

        <UiAside v-model="aside_show" />
    </div>
</template>